<template>
  <div class="folder">
    <van-pullRefresh v-model="projectResource.refreshing" @refresh="getProjectResource">
      <Empty v-if="projectResource.totalCount === 0" tip="暂无内容" />
      <div  v-else class="resourceWrap">
        <ul class="list">
          <li v-for="item in projectResource.dirs" :key="item.id" class="list-item">
            <ResourceItem
              :projectId="projectId"
              type="folder"
              :item="item"
            />
          </li>
          <li v-for="item in projectResource.files" :key="item.id" class="list-item line">
            <ResourceItem :item="item" />
          </li>
        </ul>
      </div>
    </van-pullRefresh>
  </div>
</template>

<script>
import ResourceItem from './components/ResourceItem.vue';
export default {
  name: 'Folder',
  components: { ResourceItem },
  data () {
    return {
      projectId: '',
      parentId: '',
      projectResource: {
        dirs: [],
        files: [],
        totalCount: '',
        refreshing: false
      }
    };
  },
  watch: {
    $route: {
      handler ({ name, query: { title, projectId, parentId } }) {
        if (name === 'Folder') {
          this.$route.meta.title = title;
          this.projectId = projectId;
          this.parentId = parentId;
          this.getProjectResource();
        }
      },
      immediate: true
    }
  },
  methods: {
    getProjectResource () {
      let { projectResource, projectId, parentId } = this;
      projectResource.totalCount = '';
      this.$http.get('studio/projectResource', {
        params: {
          projectId,
          parentId
        }
      }).then((res) => {
        let data = res.data;
        projectResource.dirs = data.dirs || [];
        projectResource.files = data.files || [];
        projectResource.refreshing = false;
        projectResource.totalCount = projectResource.dirs.length + projectResource.files.length;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.folder {
  padding-top: 20px;
  .resourceWrap {
    .line {
      position: relative;
      &:after{
        content: '';
        width: calc(100% - 56px);
        height: 2px;
        background-color: #F0F0F0;
        position: absolute;
        left: 28px;
        bottom: 0;
      }
    }

  }
}
</style>